var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCubeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.54 47.346L90.8589 11.4573C90.3031 11.1497 89.6969 11.1497 89.1411 11.4573L23.46 47.346C22.8537 47.6536 22.5 48.3201 22.5 48.9866V131.018C22.5 131.684 22.8537 132.3 23.46 132.658L89.1411 168.547C89.3937 168.65 89.6969 168.752 90 168.752C90.3031 168.752 90.6063 168.65 90.8589 168.547L156.54 132.658C157.146 132.3 157.5 131.684 157.5 131.018V49.0378C157.5 48.3713 157.146 47.7048 156.54 47.3972V47.346ZM88.1811 163.83L26.1377 129.89V52.0627L88.1811 85.9519V163.83ZM90 82.7732L28.1587 49.0378L90 15.2L151.841 48.9866L90 82.7732ZM153.862 129.89L91.8189 163.83V85.9519L153.862 52.0627V129.89Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.862 52.0627V129.89L91.8189 163.83V86.0032L153.862 52.0627Z",
    fill: "#7CE9DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.841 49.0378L90 82.7732L28.1587 49.0378L90 15.2L151.841 49.0378Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1811 86.0032V163.83L26.1377 129.89V52.0627L88.1811 86.0032Z",
    fill: "#D3F8F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCubeDefault);
export default __webpack_public_path__ + "static/media/ic-cube-default.e7378bbfaaf5059464336ae90c992ad6.svg";
export { ForwardRef as ReactComponent };